function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.4276 19.337C21.4276 16.7845 20.8379 14.7348 19.3438 13.3039C18.1643 12.1436 16.3558 11.3702 13.8395 11.0221L10.4583 10.558C9.47534 10.442 8.88558 10.0939 8.53173 9.74586C8.09925 9.32044 7.9813 8.81768 7.9813 8.46961C7.9813 7.27072 8.96422 5.91713 11.3625 5.91713C12.5814 5.91713 14.901 5.80111 16.6703 7.54144L20.9951 3.28729C18.5968 0.928179 15.5694 0 11.5591 0C5.18981 0 1.33677 3.67403 1.33677 8.70166C1.33677 11.0608 1.96584 12.9171 3.26329 14.232C4.52143 15.5083 6.40863 16.3204 8.88558 16.6685L12.2668 17.1326C13.1711 17.2486 13.7609 17.5193 14.1147 17.8674C14.5079 18.2928 14.6651 18.8343 14.6651 19.4917C14.6651 21.0773 13.3677 21.9669 10.6548 21.9669C8.41378 21.9669 5.8582 21.4641 4.40348 20.0331L0 24.3646C2.83081 27.2265 6.33 28 10.6155 28C16.513 28 21.4276 24.9447 21.4276 19.337Z",
  fill: "#1F55E7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.1752 18.0994V0.232046H39.2947V17.9448C39.2947 20.4972 37.8007 21.9669 35.5203 21.9669C33.24 21.9669 31.8246 20.4972 31.8246 17.9448V0.232046H24.9441V18.0994C24.9441 24.1326 29.7014 28 35.5203 28C41.3392 28 46.1752 24.1326 46.1752 18.0994Z",
  fill: "#1F55E7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.6078 9.0884C64.6078 10.5193 63.5069 11.8729 61.6197 11.8729H57.7273V6.30387H61.6197C63.5069 6.30387 64.6078 7.65746 64.6078 9.0884ZM72.9822 27.768L66.9274 16.2818C69.1292 15.1989 71.4882 12.8398 71.4882 9.0884C71.4882 4.56354 68.1463 0.232046 61.9342 0.232046H50.8469V27.768H57.7273V17.5193H60.047L65.0009 27.768H72.9822Z",
  fill: "#1F55E7"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95 27.768V21.7348H82.8511V16.9006H93.2308V10.8674H82.8511V6.26519H95V0.232046H75.9707V27.768H95Z",
  fill: "#1F55E7"
});

var SvgLogoSureWordmark = function SvgLogoSureWordmark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 95,
    height: 28,
    viewBox: "0 0 95 28",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoSureWordmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-sure-wordmark.fccf7fff.svg";
export { ForwardRef as ReactComponent };